import { render, staticRenderFns } from "./DataExtraction.vue?vue&type=template&id=678f1fa8&"
import script from "./DataExtraction.vue?vue&type=script&lang=js&"
export * from "./DataExtraction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports